import {
  useMutation,
  UseMutationOptions,
  useQuery,
} from '@tanstack/react-query';
import {
  addNewTicket,
  createTicketComment,
  deleteTicket,
  getAllHelpDesk,
  getHelpDeskDetail,
} from './api';

export const useGetAllHelpDesk = (profileId?: string) => {
  return useQuery({
    queryKey: ['help-desk-list', profileId],
    queryFn: getAllHelpDesk,
  });
};

export const useGetHelpDeskDetails = (ticketId: string) => {
  return useQuery({
    queryKey: ['help-desk-details', ticketId],
    queryFn: () => getHelpDeskDetail(ticketId),
    enabled: Boolean(ticketId),
  });
};

export const useAddHelpDeskTicket = (
  args: Omit<UseMutationOptions<unknown, Error, unknown>, 'mutationFn'>
) => {
  return useMutation({
    mutationFn: addNewTicket,
    ...args,
  });
};

export const useDeleteTicket = () => {
  return useMutation({
    mutationKey: ['help-desk-list'],
    mutationFn: deleteTicket,
  });
};

type CreateCommentArgs = Omit<
  UseMutationOptions<unknown, Error, unknown>,
  'mutationFn'
>;
export const useCreateComment = (args?: CreateCommentArgs) => {
  return useMutation({
    mutationFn: ({
      params,
      data,
    }: {
      params: { event_type?: string; ticket_id: string };
      data: FormData;
    }) => createTicketComment(params, data),
    ...args,
  });
};
